module.exports = ".values {\n    display: inline;\n    margin: 20px 0px 20px 10px;\n}\n\n.parameter {\n    float: left;\n    font-size: 15px;\n}\n\n.delete {\n    float: right;\n}\n\n.buttons {\n    text-align: right;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/user-profile-view/user-profile-view.component.css
// module id = ./src/app/components/user-profile-view/user-profile-view.component.css
// module chunks = main